import { environment } from 'src/environments/environment';

export enum ServerTypes {
    ids = 'ids',
  boapi = 'boapi',
  auth = 'auth',
    admin = 'admin',
    work = 'work',
    tfw = 'tfw',
    ptdesk ='ptdesk',
    other = 'other'
}

export const servers = [
    {
        type: ServerTypes.boapi, url: localStorage.getItem(ServerTypes.boapi)?.indexOf(',') > 0 ? localStorage.getItem(ServerTypes.boapi).split(',') : [ localStorage.getItem(ServerTypes.boapi) ]
    },
    {
        type: ServerTypes.ids,
        url: ['https://bo-api.epass24.com'],
    },
    {
        type: ServerTypes.auth,
        url: environment.authServerUrls,
    },
    {
        type: ServerTypes.ptdesk,
        url:  [ localStorage.getItem(ServerTypes.ptdesk)],
    },
    {
        type: ServerTypes.admin,
        url: [localStorage.getItem(ServerTypes.admin)],
    },
    {
        type: ServerTypes.work,
        url: ['https://app-bo-work-westeurope-01.azurewebsites.net/'],
    },
    {
        type: ServerTypes.tfw,
        url: ['https://app-bo-tfw-01-c8aac6aggghcefg2.swedencentral-01.azurewebsites.net/'],
    },
];

export const defaultServerConfig = [
    { type: ServerTypes.boapi, index: 0 },
    { type: ServerTypes.auth, index: 0 },
    { type: ServerTypes.admin, index: 0 },
    { type: ServerTypes.work, index: 0 },
    { type: ServerTypes.ptdesk, index: 0 }, 
    { type: ServerTypes.tfw, index: 0 }, 
];

export const defaultServer = ServerTypes.boapi;
